import AppearanceRow from "./AppearanceRow";
import FontSizeRow from "./FontSizeRow";
import LanguageRow from "./LanguageRow";
import ShowImagesRow from "./ShowImagesRow";

export default function AppearanceSection() {
  return (
    <div className="flex flex-col flex-1">
      <AppearanceRow />
      <FontSizeRow />
      <ShowImagesRow />
      <LanguageRow />
    </div>
  );
}
